import type {
  ChannelThreadId,
  SupportTicketId,
} from "@redotech/effect-api-shared/ids/definitions";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface MobileMessageThreadViewProps {
  messageThreadIds?: readonly ChannelThreadId[];
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const MobileMessageThreadView = memo(function MobileMessageThreadView({
  messageThreadIds,
  supportTicketId,
  thread,
}: MobileMessageThreadViewProps) {
  return (
    <ChatThreadView
      allowReplies={false}
      channel="mobileMessage"
      messageThreadIds={messageThreadIds}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
